/* Generado por generar_opciones_selector.py. NO editar a mano.
   Son los filtros y valores que el escaparate ofrece de verdad,
   comprobados uno a uno contra la tienda.
   Regenerar: py generar_opciones_selector.py --escribir */
window.OPCIONES_SELECTOR = {
 "impresora-portatiles": {
  "filtros": {
   "filter.p.m.custom.ancho_impresion": [
    "2\"",
    "3\"",
    "4\"",
    "5\"",
    "6\""
   ],
   "filter.p.m.custom.frecuencia_rfid": [
    "UHF"
   ],
   "filter.p.m.custom.interfaces": [
    "Bluetooth",
    "Ethernet",
    "Serie (RS-232)",
    "USB",
    "Wi-Fi"
   ],
   "filter.p.m.custom.protocolo_rfid": [
    "EPC Gen2"
   ],
   "filter.p.m.custom.resolucion_impresion": [
    "203 dpi",
    "300 dpi",
    "360 dpi",
    "720 dpi"
   ],
   "filter.p.m.custom.tecnologia_impresion": [
    "Transferencia térmica",
    "Térmica directa",
    "Térmica directa y transferencia térmica"
   ]
  },
  "handle": "impresora-portatiles",
  "recuentos": {
   "filter.p.m.custom.ancho_impresion": {
    "2\"": 17,
    "3\"": 17,
    "4\"": 17,
    "5\"": 5,
    "6\"": 9
   },
   "filter.p.m.custom.frecuencia_rfid": {
    "UHF": 1
   },
   "filter.p.m.custom.interfaces": {
    "Bluetooth": 75,
    "Ethernet": 44,
    "Serie (RS-232)": 43,
    "USB": 88,
    "Wi-Fi": 68
   },
   "filter.p.m.custom.protocolo_rfid": {
    "EPC Gen2": 1
   },
   "filter.p.m.custom.resolucion_impresion": {
    "203 dpi": 59,
    "300 dpi": 15,
    "360 dpi": 1,
    "720 dpi": 2
   },
   "filter.p.m.custom.tecnologia_impresion": {
    "Transferencia térmica": 35,
    "Térmica directa": 52,
    "Térmica directa y transferencia térmica": 1
   }
  },
  "total": 105
 },
 "impresoras-1": {
  "filtros": {
   "filter.p.m.custom.ancho_impresion": [
    "1\"",
    "2\"",
    "3\"",
    "4\"",
    "5\"",
    "6\"",
    "8\""
   ],
   "filter.p.m.custom.frecuencia_rfid": [
    "HF",
    "UHF"
   ],
   "filter.p.m.custom.interfaces": [
    "Bluetooth",
    "Ethernet",
    "Paralelo",
    "Serie (RS-232)",
    "USB",
    "Wi-Fi"
   ],
   "filter.p.m.custom.protocolo_rfid": [
    "EPC Gen2",
    "ISO 14443"
   ],
   "filter.p.m.custom.resolucion_impresion": [
    "203 dpi",
    "300 dpi",
    "360 dpi",
    "600 dpi",
    "720 dpi"
   ],
   "filter.p.m.custom.tecnologia_impresion": [
    "Inyección de tinta",
    "Matricial",
    "Transferencia térmica",
    "Térmica directa",
    "Térmica directa y transferencia térmica"
   ]
  },
  "handle": "impresoras-1",
  "recuentos": {
   "filter.p.m.custom.ancho_impresion": {
    "1\"": 1,
    "2\"": 74,
    "3\"": 41,
    "4\"": 297,
    "5\"": 15,
    "6\"": 47,
    "8\"": 1
   },
   "filter.p.m.custom.frecuencia_rfid": {
    "HF": 1,
    "UHF": 9
   },
   "filter.p.m.custom.interfaces": {
    "Bluetooth": 423,
    "Ethernet": 484,
    "Paralelo": 196,
    "Serie (RS-232)": 434,
    "USB": 537,
    "Wi-Fi": 494
   },
   "filter.p.m.custom.protocolo_rfid": {
    "EPC Gen2": 8,
    "ISO 14443": 1
   },
   "filter.p.m.custom.resolucion_impresion": {
    "203 dpi": 310,
    "300 dpi": 156,
    "360 dpi": 1,
    "600 dpi": 21,
    "720 dpi": 2
   },
   "filter.p.m.custom.tecnologia_impresion": {
    "Inyección de tinta": 8,
    "Matricial": 2,
    "Transferencia térmica": 350,
    "Térmica directa": 159,
    "Térmica directa y transferencia térmica": 13
   }
  },
  "total": 627
 },
 "impresoras-rfid": {
  "filtros": {
   "filter.p.m.custom.ancho_impresion": [
    "2\"",
    "4\"",
    "6\""
   ],
   "filter.p.m.custom.frecuencia_rfid": [
    "UHF"
   ],
   "filter.p.m.custom.interfaces": [
    "Bluetooth",
    "Ethernet",
    "Paralelo",
    "Serie (RS-232)",
    "USB",
    "Wi-Fi"
   ],
   "filter.p.m.custom.protocolo_rfid": [
    "EPC Gen2"
   ],
   "filter.p.m.custom.resolucion_impresion": [
    "203 dpi",
    "300 dpi"
   ],
   "filter.p.m.custom.tecnologia_impresion": [
    "Transferencia térmica",
    "Térmica directa"
   ]
  },
  "handle": "impresoras-rfid",
  "recuentos": {
   "filter.p.m.custom.ancho_impresion": {
    "2\"": 3,
    "4\"": 17,
    "6\"": 9
   },
   "filter.p.m.custom.frecuencia_rfid": {
    "UHF": 4
   },
   "filter.p.m.custom.interfaces": {
    "Bluetooth": 33,
    "Ethernet": 32,
    "Paralelo": 22,
    "Serie (RS-232)": 32,
    "USB": 33,
    "Wi-Fi": 33
   },
   "filter.p.m.custom.protocolo_rfid": {
    "EPC Gen2": 4
   },
   "filter.p.m.custom.resolucion_impresion": {
    "203 dpi": 15,
    "300 dpi": 14
   },
   "filter.p.m.custom.tecnologia_impresion": {
    "Transferencia térmica": 26,
    "Térmica directa": 3
   }
  },
  "total": 37
 },
 "lectores-de-codigos-de-barras": {
  "filtros": {
   "filter.p.m.custom.conectividad": [
    "4G",
    "Bluetooth",
    "NFC",
    "Wi-Fi"
   ],
   "filter.p.m.custom.dimension_codigo": [
    "1D",
    "2D"
   ],
   "filter.p.m.custom.interfaces": [
    "Bluetooth",
    "Ethernet",
    "Paralelo",
    "Serie (RS-232)",
    "USB",
    "Wi-Fi"
   ],
   "filter.p.m.custom.proteccion_ip": [
    "IP40",
    "IP41",
    "IP42",
    "IP50",
    "IP52",
    "IP53",
    "IP54",
    "IP65",
    "IP67"
   ],
   "filter.p.m.custom.sistema_operativo": [
    "Android"
   ],
   "filter.p.m.custom.tamano_pantalla": [
    "4\" - 5\"",
    "Hasta 4\""
   ],
   "filter.p.m.custom.tipo_conexion": [
    "Con cable",
    "Inalámbrico"
   ]
  },
  "handle": "lectores-de-codigos-de-barras",
  "recuentos": {
   "filter.p.m.custom.conectividad": {
    "4G": 2,
    "Bluetooth": 12,
    "NFC": 2,
    "Wi-Fi": 13
   },
   "filter.p.m.custom.dimension_codigo": {
    "1D": 197,
    "2D": 739
   },
   "filter.p.m.custom.interfaces": {
    "Bluetooth": 231,
    "Ethernet": 230,
    "Paralelo": 60,
    "Serie (RS-232)": 526,
    "USB": 740,
    "Wi-Fi": 7
   },
   "filter.p.m.custom.proteccion_ip": {
    "IP40": 30,
    "IP41": 7,
    "IP42": 25,
    "IP50": 1,
    "IP52": 244,
    "IP53": 7,
    "IP54": 26,
    "IP65": 298,
    "IP67": 18
   },
   "filter.p.m.custom.sistema_operativo": {
    "Android": 17
   },
   "filter.p.m.custom.tamano_pantalla": {
    "4\" - 5\"": 4,
    "Hasta 4\"": 10
   },
   "filter.p.m.custom.tipo_conexion": {
    "Con cable": 596,
    "Inalámbrico": 255
   }
  },
  "total": 2225
 },
 "lectores-fijos": {
  "filtros": {
   "filter.p.m.custom.dimension_codigo": [
    "1D",
    "2D"
   ],
   "filter.p.m.custom.interfaces": [
    "Bluetooth",
    "Ethernet",
    "Paralelo",
    "Serie (RS-232)",
    "USB"
   ],
   "filter.p.m.custom.proteccion_ip": [
    "IP40",
    "IP52",
    "IP54",
    "IP65",
    "IP67"
   ],
   "filter.p.m.custom.tipo_conexion": [
    "Con cable",
    "Inalámbrico"
   ]
  },
  "handle": "lectores-fijos",
  "recuentos": {
   "filter.p.m.custom.dimension_codigo": {
    "1D": 33,
    "2D": 291
   },
   "filter.p.m.custom.interfaces": {
    "Bluetooth": 1,
    "Ethernet": 154,
    "Paralelo": 31,
    "Serie (RS-232)": 209,
    "USB": 243
   },
   "filter.p.m.custom.proteccion_ip": {
    "IP40": 10,
    "IP52": 34,
    "IP54": 15,
    "IP65": 107,
    "IP67": 4
   },
   "filter.p.m.custom.tipo_conexion": {
    "Con cable": 278,
    "Inalámbrico": 2
   }
  },
  "total": 414
 },
 "rfid": {
  "filtros": {
   "filter.p.m.custom.ancho_impresion": [
    "2\"",
    "4\"",
    "6\""
   ],
   "filter.p.m.custom.dimension_codigo": [
    "2D"
   ],
   "filter.p.m.custom.frecuencia_rfid": [
    "UHF"
   ],
   "filter.p.m.custom.interfaces": [
    "Bluetooth",
    "Ethernet",
    "Paralelo",
    "Serie (RS-232)",
    "USB",
    "Wi-Fi"
   ],
   "filter.p.m.custom.proteccion_ip": [
    "IP65"
   ],
   "filter.p.m.custom.protocolo_rfid": [
    "EPC Gen2"
   ],
   "filter.p.m.custom.resolucion_impresion": [
    "203 dpi",
    "300 dpi"
   ],
   "filter.p.m.custom.sistema_operativo": [
    "Android"
   ],
   "filter.p.m.custom.tamano_pantalla": [
    "5\" - 6\""
   ],
   "filter.p.m.custom.tecnologia_impresion": [
    "Transferencia térmica",
    "Térmica directa"
   ],
   "filter.p.m.custom.tipo_conexion": [
    "Inalámbrico"
   ]
  },
  "handle": "rfid",
  "recuentos": {
   "filter.p.m.custom.ancho_impresion": {
    "2\"": 3,
    "4\"": 17,
    "6\"": 9
   },
   "filter.p.m.custom.dimension_codigo": {
    "2D": 5
   },
   "filter.p.m.custom.frecuencia_rfid": {
    "UHF": 78
   },
   "filter.p.m.custom.interfaces": {
    "Bluetooth": 106,
    "Ethernet": 97,
    "Paralelo": 46,
    "Serie (RS-232)": 43,
    "USB": 105,
    "Wi-Fi": 94
   },
   "filter.p.m.custom.proteccion_ip": {
    "IP65": 5
   },
   "filter.p.m.custom.protocolo_rfid": {
    "EPC Gen2": 77
   },
   "filter.p.m.custom.resolucion_impresion": {
    "203 dpi": 15,
    "300 dpi": 14
   },
   "filter.p.m.custom.sistema_operativo": {
    "Android": 2
   },
   "filter.p.m.custom.tamano_pantalla": {
    "5\" - 6\"": 2
   },
   "filter.p.m.custom.tecnologia_impresion": {
    "Transferencia térmica": 26,
    "Térmica directa": 3
   },
   "filter.p.m.custom.tipo_conexion": {
    "Inalámbrico": 5
   }
  },
  "total": 322
 },
 "rfid-lectores": {
  "filtros": {
   "filter.p.m.custom.dimension_codigo": [
    "2D"
   ],
   "filter.p.m.custom.frecuencia_rfid": [
    "UHF"
   ],
   "filter.p.m.custom.interfaces": [
    "Bluetooth",
    "Ethernet",
    "Paralelo",
    "Serie (RS-232)",
    "USB",
    "Wi-Fi"
   ],
   "filter.p.m.custom.proteccion_ip": [
    "IP65"
   ],
   "filter.p.m.custom.protocolo_rfid": [
    "EPC Gen2"
   ],
   "filter.p.m.custom.sistema_operativo": [
    "Android"
   ],
   "filter.p.m.custom.tamano_pantalla": [
    "5\" - 6\""
   ],
   "filter.p.m.custom.tipo_conexion": [
    "Inalámbrico"
   ]
  },
  "handle": "rfid-lectores",
  "recuentos": {
   "filter.p.m.custom.dimension_codigo": {
    "2D": 3
   },
   "filter.p.m.custom.frecuencia_rfid": {
    "UHF": 41
   },
   "filter.p.m.custom.interfaces": {
    "Bluetooth": 39,
    "Ethernet": 34,
    "Paralelo": 10,
    "Serie (RS-232)": 4,
    "USB": 40,
    "Wi-Fi": 31
   },
   "filter.p.m.custom.proteccion_ip": {
    "IP65": 3
   },
   "filter.p.m.custom.protocolo_rfid": {
    "EPC Gen2": 40
   },
   "filter.p.m.custom.sistema_operativo": {
    "Android": 2
   },
   "filter.p.m.custom.tamano_pantalla": {
    "5\" - 6\"": 2
   },
   "filter.p.m.custom.tipo_conexion": {
    "Inalámbrico": 3
   }
  },
  "total": 52
 },
 "tablets-y-complementos": {
  "filtros": {
   "filter.p.m.custom.conectividad": [
    "4G",
    "5G",
    "Bluetooth",
    "NFC",
    "Wi-Fi"
   ],
   "filter.p.m.custom.dimension_codigo": [
    "2D"
   ],
   "filter.p.m.custom.frecuencia_rfid": [
    "UHF"
   ],
   "filter.p.m.custom.interfaces": [
    "Bluetooth",
    "Ethernet",
    "Paralelo",
    "USB",
    "Wi-Fi"
   ],
   "filter.p.m.custom.protocolo_rfid": [
    "EPC Gen2",
    "ISO 14443",
    "ISO 15693"
   ],
   "filter.p.m.custom.sistema_operativo": [
    "Android",
    "Windows"
   ],
   "filter.p.m.custom.tamano_pantalla": [
    "4\" - 5\"",
    "5\" - 6\"",
    "6\" - 8\"",
    "8\" o más",
    "Hasta 4\""
   ],
   "filter.p.m.custom.tipo_conexion": [
    "Inalámbrico"
   ]
  },
  "handle": "tablets-y-complementos",
  "recuentos": {
   "filter.p.m.custom.conectividad": {
    "4G": 244,
    "5G": 193,
    "Bluetooth": 569,
    "NFC": 131,
    "Wi-Fi": 696
   },
   "filter.p.m.custom.dimension_codigo": {
    "2D": 13
   },
   "filter.p.m.custom.frecuencia_rfid": {
    "UHF": 32
   },
   "filter.p.m.custom.interfaces": {
    "Bluetooth": 36,
    "Ethernet": 32,
    "Paralelo": 16,
    "USB": 32,
    "Wi-Fi": 44
   },
   "filter.p.m.custom.protocolo_rfid": {
    "EPC Gen2": 30,
    "ISO 14443": 2,
    "ISO 15693": 2
   },
   "filter.p.m.custom.sistema_operativo": {
    "Android": 694,
    "Windows": 36
   },
   "filter.p.m.custom.tamano_pantalla": {
    "4\" - 5\"": 262,
    "5\" - 6\"": 209,
    "6\" - 8\"": 19,
    "8\" o más": 38,
    "Hasta 4\"": 227
   },
   "filter.p.m.custom.tipo_conexion": {
    "Inalámbrico": 10
   }
  },
  "total": 1669
 }
};
